module.exports = __webpack_public_path__ + "static/media/homeTitle5.4d94aaf1.png";